(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["looftys-email-letter"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Corrected the ID to match the Shopify form ID exactly
  const form = document.querySelector('#LooftysNewsletter');
  
  if (!form) {
    console.warn('Newsletter form not found by Javascript.');
    return;
  }

  form.addEventListener('submit', function(e) {
    e.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    const successMsg = form.querySelector('.looftys-email__success');
    
    // 1. Swap text for loader
    button.classList.add('is-loading');
    
    const formData = new FormData(form);

    // 2. Submit via AJAX
    fetch(form.action, {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'text/html'
      }
    })
    .then(response => {
      // 3. Remove loader and show text
      button.classList.remove('is-loading');
      
      if (response.ok) {
        // 4. Show success text & clear input
        if (successMsg) successMsg.style.display = 'block';
        form.reset();
        
        // Hide success message after 5 seconds
        setTimeout(() => {
          if (successMsg) successMsg.style.display = 'none';
        }, 5000);
      }
    })
    .catch(error => {
      button.classList.remove('is-loading');
      console.error('Newsletter submission error:', error);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
